/**
 * @file index.js
 * @description Entry point for the SecureCheck React application, initializing root DOM rendering and error boundary wrapper.
 */

import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";

import "./css/base.css";
import "./css/layout.css";
import "./css/components.css";
import "./css/responsive.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Suspense
        fallback={<div className="app-loading">Loading SecureCheck…</div>}
      >
        <App />
      </Suspense>
    </ErrorBoundary>
  </React.StrictMode>,
);
